var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorruptIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 5.5zM0 3v10c0 .55.45 1 1 1h6v-1H1.002L1 12.998V3.002L1.002 3H7V2H1c-.55 0-1 .45-1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9V0H8v16h1v-2h6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 10.998l-.002.002H9v-1h5V7l-3.5 3h-1L9 9.375V3h5.998l.002.002v9.996zM2 11v1h5V6.875L5.5 5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorruptIcon);
export default __webpack_public_path__ + "static/media/corrupt-icon.d0f19c4a641f0d5e80d1e82356c5d974.svg";
export { ForwardRef as ReactComponent };